import React, { useEffect, useState, useMemo } from "react";
import ReactTable from "react-table-v6";
import { Link, useLocation } from "react-router-dom";
import { formatDate } from "../../../../../../formatDate";
import Loader from "../../../../../../settings/loader";
import "react-table-v6/react-table.css";
import "./style.scss";

function Slider4(props) {
  const location = useLocation();
  const [data, setData] = useState({
    result: null,
    table: [],
  });
  const [load, setLoad] = useState(0);

  // Initialize result when props.data and filter are ready
  useEffect(() => {
    if (props.data && !load) {
      setData((prev) => ({
        ...prev,
        result: {
          ...props.filter.data,
          ...props.data,
        },
      }));
      setLoad(1);
    }
    // eslint-disable-next-line
  }, [props.data, props.filter, load]);

  // Prepare table data when result is set
  useEffect(() => {
    if (load === 1 && data.result) {
      setData((prev) => ({
        ...prev,
        table: data.result.audit.data.sort(sortSales).map((row) => {
          const chain = data.result.chains.find(
            (chain) => chain.chaKey === row.chaKey
          );
          const brand = data.result.brands.find(
            (brand) => brand.braKey === row.braKey
          );
          return {
            ...row,
            businessName: `${brand?.name || ""} - ${chain?.name || ""}`,
          };
        }),
      }));
      setLoad(2);
    }
    // eslint-disable-next-line
  }, [load, data.result]);

  // Export logic
  useEffect(() => {
    if (props.export && data.table.length) {
      props.getData({
        type: "table",
        title: "Audit Summary",
        filter: {
          brands: props.filter.data.brands.map((brand) => brand.name),
          chains: props.filter.data.chains.map((chain) => chain.name),
          revCent: props.filter.data.revCent.map((revCent) => revCent.name),
          payType: props.filter.data.payType.map((payType) => payType.name),
          date: {
            start: props.filter.data.date.start,
            end: props.filter.data.date.end,
          },
        },
        body: [
          {
            head: [["Id", "Bill No", "Type", "Date", "Business Name"]],
            body: data.table.map((value) => [
              value.audId,
              value.billNo,
              value.type[0] ? value.type[0].name : "",
              formatDate.long(value.date),
              value.businessName,
            ]),
          },
        ],
      });
    }
    // eslint-disable-next-line
  }, [props.export, data.table]);

  function sortSales(a, b) {
    if (parseInt(a.date) > parseInt(b.date)) return -1;
    if (parseInt(a.date) < parseInt(b.date)) return 1;
    return 0;
  }

  // Unique business names for filter dropdown
  const uniqueNames = useMemo(() => {
    if (!data.table) return [];
    return [...new Set(data.table.map((table) => table.businessName))];
  }, [data.table]);

  // Render link for table cells
  const renderLink = (component) => (
    <Link
      to={`/${location.pathname.split("/")[1]}/view/${
        location.pathname.split("/")[2]
      }/${component.data._id}`}
      state={{ prevUrl: location.pathname }}
    >
      {component.value}
    </Link>
  );

  const columns = [
    {
      Header: "Business Name",
      accessor: "businessName",
      filterMethod: (filter, row) => {
        if (filter.value === "all") return true;
        return row[filter.id] === filter.value;
      },
      Filter: ({ filter, onChange }) => (
        <select
          onChange={(event) => onChange(event.target.value)}
          style={{ width: "100%" }}
          value={filter ? filter.value : "all"}
        >
          <option value="all">All</option>
          {uniqueNames.map((name) => (
            <option value={name} key={name}>
              {name}
            </option>
          ))}
        </select>
      ),
      Cell: (row) => renderLink({ data: row.row._original, value: row.value }),
    },
    {
      Header: "ID",
      accessor: "audId",
      Cell: (row) => renderLink({ data: row.row._original, value: row.value }),
    },
    {
      Header: "Order No.",
      accessor: "billNo",
      Cell: (row) => renderLink({ data: row.row._original, value: row.value }),
    },
    {
      Header: "Employee",
      accessor: "employee",
      Cell: (row) => {
        // Try to get employee name from saleData.emp[0].name if available
        const empName = row.row._original?.emp?.[0]?.name || "";
        return empName;
      },
    },
    {
      Header: "Type",
      accessor: "type",
      filterMethod: (filter, row) => {
        const id = filter.pivotId || filter.id;
        return row[id][0]?.name
          ? String(row[id][0].name.toLowerCase()).includes(
              filter.value.toLowerCase()
            )
          : true;
      },
      Filter: ({ filter, onChange }) => (
        <input
          type="text"
          onChange={(event) => onChange(event.target.value)}
          style={{ width: "100%" }}
          value={filter ? filter.value : ""}
        />
      ),
      Cell: (row) =>
        renderLink({
          data: row.row._original,
          value: row.value[0] ? row.value[0].name : "",
        }),
    },
    {
      Header: "Date",
      accessor: "date",
      Cell: (row) =>
        renderLink({
          data: row.row._original,
          value: formatDate.long(row.value),
        }),
    },
  ];

  return (
    <div>
      {/* <h1>Audit Trails</h1> */}
      {load < 2 ? (
        <Loader />
      ) : (
        <ReactTable
          className="-striped -highlight"
          data={data.table}
          columns={columns}
          sortable
          filterable
          getTdProps={() => ({
            style: {
              textAlign: "center",
            },
          })}
        />
      )}
    </div>
  );
}

export default Slider4;
